export default {"src":"/_next/static/media/indiaMexico.692999c2.svg","height":132,"width":146};